import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { NotesTextEditCrumbs } from 'civil-status/constants/notes-text-breadcrumb';
import FormNotesText, { NotesTextForm } from 'civil-status/components/notes-text/form';
import { useNavigate, useParams } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';
import { HttpResponse } from 'shell/models/http-response';
import { NotesText } from 'shell/models/notes-text';
import { transformResponseNoteText } from 'civil-status/utils/transformer-note-text';

const NotesTextEditPage = (): React.ReactElement => {
  const navigate = useNavigate();
  const params = useParams();

  const updateNotesText = useHttpClient(
    `${__CIVIL_STATUS_API_URL__}/testo-annotazione/aggiornamento-testo-annotazione`,
    {
      options: {
        method: 'PUT',
      },
    }
  );

  const [noteText] = useHttpFetch<HttpResponse<NotesText>, NotesTextForm>(
    `${__CIVIL_STATUS_API_URL__}/testo-annotazione/${params.id}`,
    {
      onBootstrap: true,
      transformer: transformResponseNoteText,
    }
  );

  const handleSubmit = useCallback(
    (values) => {
      (
        updateNotesText({
          data: {
            key: {
              idAnnotazione: params.id,
            },
            titolo: values.title || '',
            annotazione: values.text || '',
            tipoAnnotazione: values.type || '',
          },
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/annotazioni');
      });
    },
    [updateNotesText, navigate]
  );

  const isLoading = noteText.isLoading || noteText.pristine || noteText.hasErrors;

  return (
    <Fragment>
      <Breadcrumbs items={NotesTextEditCrumbs} />
      {!isLoading ? (
        <FormNotesText
          title={'Modifica Annotazione'}
          onOk={handleSubmit}
          onCancel={() => {
            navigate('/stato-civile/annotazioni');
          }}
          isEdit
          initialValues={noteText.data as NotesTextForm}
        ></FormNotesText>
      ) : undefined}
    </Fragment>
  );
};

NotesTextEditPage.displayName = 'Notes Text Edit page component';

export default NotesTextEditPage;
